import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import {
  Alert,
  Badge,
  Button,
  Card,
  Col,
  Container,
  Image,
  Row,
} from "react-bootstrap";
import { connect } from "react-redux";
import {
  deleteProductFamily,
  getFamiliesCount,
  getFamiliesPaginated,
} from "../../actions/imagedatabase/productsFamilies";
import APIUrl from "../../APIUrl";
import ConfirmationModal from "../sub/modals/ConfirmationModal";
import TableToolbar from "../sub/bootstrap/TableToolbar";
import Notification from "../sub/Notification";
import Icon from "../sub/Icon";
import Paginator from "../sub/Paginator";
import LoadingSpinner from "../sub/LoadingSpinner";
import FamilyModal from "./FamilyModal";

class FamiliesDatabase extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: null,
      keywordFilter: "",
      isInitialLoading: true,
      isLoading: false,
      totalProductsFamilies: 0,
    };

    this.paginator = new Paginator(this);
    this.timeout = null;
  }

  async componentDidMount() {
    try {
      await this.fetchProductsFamilies();
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      this.setState({ isInitialLoading: false });
    }
  }

  async fetchProductsFamilies() {
    this.setState({ isLoading: true });
    this.paginator.disabled = true;

    await this.props.onGetProductsFamiliesPaginated(
      this.paginator.paginationIndex,
      this.paginator.paginationElems,
      this.state.keywordFilter,
    );

    await new Promise((resolve) => {
      this.props.onGetProductsFamiliesCount((data) => {
        this.setState({ totalProductsFamilies: data, isLoading: false });
        this.paginator.disabled = false;
        resolve();
      });
    });
  }

  closeModal() {
    this.setState({ modal: null });
  }

  openConfModal(title, content, successCallback) {
    this.setState({
      modal: (
        <ConfirmationModal
          size="md"
          title={title}
          content={content}
          successCallback={successCallback}
          closeModal={() => this.closeModal()}
        />
      ),
    });
  }

  deleteImage(id) {
    const successCallback = () => {
      Notification({
        type: "success",
        description: this.props.intl.formatMessage({
          id: "Image.Remove.Success",
        }),
      });

      this.closeModal();
      this.fetchProductsFamilies();
    };

    this.props.onDeleteProductFamily({ _id: id }, successCallback);
  }

  onKeywordFilterChange(value) {
    this.setState({ keywordFilter: value });

    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.fetchProductsFamilies();
    }, 800);
  }

  openFamilyModal(family) {
    this.setState({
      modal: (
        <FamilyModal
          family={family}
          closeModal={() => this.closeModal()}
          fetchProductsFamilies={() => this.fetchProductsFamilies()}
        />
      ),
    });
  }

  render() {
    const { productsFamilies } = this.props;

    this.paginator.init(
      this.state.totalProductsFamilies,
      this.state.totalProductsFamilies,
      () => this.fetchProductsFamilies(),
    );

    return (
      <Container fluid>
        <TableToolbar>
          <Col>
            <div className="form-inline">
              <input
                id="keyword"
                className="form-control form-control-sm mr-sm-3"
                type="search"
                value={this.state.keywordFilter}
                onChange={(e) => this.onKeywordFilterChange(e.target.value)}
                placeholder={this.props.intl.formatMessage({
                  id: "Search",
                })}
              />

              <Button
                variant="info"
                className="ml-auto"
                onClick={() => this.openFamilyModal()}
              >
                <Icon icon="circle-plus" /> <FormattedMessage id="Add.Image" />
              </Button>
            </div>
          </Col>
        </TableToolbar>

        {this.state.isInitialLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            {productsFamilies && productsFamilies.length <= 0 && (
              <Alert variant="secondary" className="mt-3">
                <FormattedMessage id="Empty.Family" />
              </Alert>
            )}

            {productsFamilies && productsFamilies.length > 0 && (
              <Row md={6} className="mb-3">
                {productsFamilies.map((family) => (
                  <Col className="mb-4" key={family._id}>
                    <Card bg={"light"} className={"h-100"}>
                      <Card.Body className="d-flex flex-column cursor-pointer">
                        <Image
                          src={`${APIUrl.getFamilyImg}${family._id}/?token=${APIUrl.jwtToken}`}
                          thumbnail
                          alt=""
                        />
                        <Row>
                          <Col className="text-center ps-0 pe-0 mt-2">
                            <small>
                              <strong>
                                <span>{family._id}</span>
                              </strong>
                            </small>
                          </Col>
                        </Row>
                        <Row>
                          {family.keywords &&
                            family.keywords.length !== 0 &&
                            family.keywords.map((k) => (
                              <Col
                                className="text-center ps-0 pe-0 mt-2"
                                key={k}
                              >
                                <Badge size="sm" variant={"secondary"}>
                                  {k}
                                </Badge>
                              </Col>
                            ))}
                        </Row>
                      </Card.Body>
                      <Card.Footer className="text-center">
                        <Button
                          variant="info"
                          size="sm"
                          onClick={() => this.openFamilyModal(family)}
                        >
                          <Icon icon="pen-to-square" />
                          <FormattedMessage id="Edit" />
                        </Button>
                        <Button
                          className="ml-3"
                          size="sm"
                          variant="danger"
                          onClick={() =>
                            this.openConfModal(
                              <FormattedMessage id="Warning" />,
                              <div>
                                <Alert variant="danger">
                                  <FormattedMessage id="Image.Warning" />
                                </Alert>
                                <FormattedMessage id="Remove.Image.Confirmation" />
                              </div>,
                              () => this.deleteImage(family._id),
                            )
                          }
                        >
                          <Icon icon="trash" />
                        </Button>
                      </Card.Footer>
                    </Card>
                  </Col>
                ))}
              </Row>
            )}

            {this.paginator.render()}

            {this.state.modal}
          </>
        )}
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    productsFamilies: state.productsFamilies,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetProductsFamiliesPaginated: (page, limit, searchQuery) =>
      dispatch(getFamiliesPaginated(page, limit, searchQuery)),
    onGetProductsFamiliesCount: (successCallback) =>
      dispatch(getFamiliesCount(successCallback)),
    onDeleteProductFamily: (data, successCallback) =>
      dispatch(deleteProductFamily(data, successCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(FamiliesDatabase));
